import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsThisFor() {
  const forList = ['Your child has been diagnosed with autism, ASD or is awaiting evaluation', 'Meltdowns are happening at home, in the car, at school or in public', "You've tried other strategies and they work sometimes but not consistently", "You're exhausted from improvising and ready for a system you can actually trust", "You want to understand your child's brain, not just manage his behavior"];
  const notForList = ['Parents looking for a cure or a way to change who their child is', 'Anyone expecting overnight transformation with zero effort', 'Parents who prefer a purely clinical, jargon-heavy academic approach'];
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-cream" data-id="element-234">
      <div className="max-w-5xl mx-auto" data-id="element-235">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16" data-id="element-236">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-sage" data-id="element-237">
            <h3 className="text-2xl font-serif text-charcoal mb-8 flex items-center" data-id="element-238">
              <span className="bg-sage-light p-2 rounded-full mr-4" data-id="element-239">
                <CheckCircle2 className="w-6 h-6 text-sage" data-id="element-240" />
              </span>
              Who This Is For
            </h3>
            <ul className="space-y-6" data-id="element-241">
              {forList.map((item, index) => <li key={index} className="flex items-start space-x-4" data-id="element-242">
                  <CheckCircle2 className="w-6 h-6 text-sage shrink-0 mt-0.5" data-id="element-243" />
                  <span className="text-lg text-charcoal-light leading-relaxed" data-id="element-244">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-red-200" data-id="element-245">
            <h3 className="text-2xl font-serif text-charcoal mb-8 flex items-center" data-id="element-246">
              <span className="bg-red-50 p-2 rounded-full mr-4" data-id="element-247">
                <XCircle className="w-6 h-6 text-red-400" data-id="element-248" />
              </span>
              Who This Is NOT For
            </h3>
            <ul className="space-y-6" data-id="element-249">
              {notForList.map((item, index) => <li key={index} className="flex items-start space-x-4" data-id="element-250">
                  <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-251" />
                  <span className="text-lg text-charcoal-light leading-relaxed" data-id="element-252">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}